
import { Vue } from "vue-class-component";

export default class NoSidebar extends Vue {}
